import {put, select} from 'redux-saga/effects';
import EditableActions from "../../EditableTable/actions";
import { TableName } from '../../EditableTable/TableName';

const {
    setItems,
} = EditableActions.withName(TableName.form_item);

export function* onUpdateFormItems() {
    const state = yield select();

    const { settings, productList } = state.List;
    const { selections, lists, originType } = state.TransactionTransfer;
    const list = lists.itemModal;
    const { items } = state.Editable[TableName.form_item]; // Init Items

    // Step 1: Flatten the nested selections
    // - Refer to src/redux/TransactionTransfer/reducer.js (Data Structure of selections)
    // - selections contains only transactionId and items (with id, applyQty)
    // - To get other info e.g. product_id, need to merge with lists

    const flattenSelections = selections
        .reduce((acc, { transactionId, items }) => [
            ...acc,
            ...items.map(item => ({ ...item, transactionId, transactionItemId: item.id })),
        ], [])
        .filter(s => !(s.applyQty === null || s.applyQty === 0));

    // Step 2: Flatten the nested List (filtered, sorted as well)
    const flattenList = list
        .map(l => ({
            ...l,
            sortIdx: selections.findIndex(({ transactionId }) => transactionId === l.id),
        }))
        .filter(l => l.sortIdx >= 0)
        .sort((a, b) => a.sortIdx - b.sortIdx)
        .reduce((acc, { form_items, ...transaction}) => [
            ...acc,
            ...form_items.map(item => ({
                ...item,
                ...transaction,
                transactionId: transaction.id,
                transactionItemId: item.id,
                description: item.description,
                type: item.type,
                children: item.children,
            })),
        ], []);

    // Step 3: Merge the flatten selections with the flatten list (sorted as well)
    // - To get info from the flatten list (e.g. product_id, date)
    const flattenSelectionsWithInfo = flattenSelections
        .map(selection => {
            const listIdx = flattenList.findIndex(item => (
                item.transactionId === selection.transactionId &&
                item.transactionItemId === selection.transactionItemId
            ));

            return {
                selection,
                list: listIdx >= 0 ? flattenList[listIdx] : {},
                sortIdx: listIdx,
            };
        })
        .sort((a, b) => a.sortIdx - b.sortIdx);

    // Step 2: Add in Transfer-from Information
    // - Refer to src/redux/TransactionTransfer/documentation.txt
    // - item.transfer_transaction = { id: int, date: "YYYY-MM-DD", number: str, type: Type }
    // - item.transfer_item_id: int
    const newItems = [...items];

    flattenSelectionsWithInfo.forEach(({ selection, list }) => {
        const product = productList?.find(p => p.id === list.product_id);
        const classification_code = product?.classification_code;

        // New Item with Transfer-From Info
        const newItem = {
            transfer_transaction: {
                id: selection.transactionId,
                type: originType,
                number: list.number,
                date: list.date,
            },
            transfer_item_id: selection.transactionItemId,

            type: list.type,
            product_id: list.product_id,
            account_id: list.account_id,
            quantity: selection.applyQty,
            location_id: list.location_id,
            product_unit_id: list.product_unit_id,
            unit_price: list.unit_price,

            // Can be overwritten
            description: list.description,
            service_date: settings.service_date_on ? (list.service_date || null) : undefined,
            discount: list.discount,
            tax_code_id: list.tax_code_id,
            classification_code: list.classification_code || classification_code,

            // Bundle Items (only)
            children: list.children?.map(child => {
                const childProduct = productList?.find(p => p.id === child.product_id);
                const classification_code = child.classification_code || childProduct?.classification_code;

                return ({
                    transfer_item_id: child.id,

                    type: child.type,
                    product_id: child.product_id,
                    account_id: child.account_id,
                    quantity: child.quantity,
                    location_id: child.location_id,
                    product_unit_id: child.product_unit_id,
                    unit_price: child.unit_price,

                    // Can be overwritten
                    description: child.description,
                    discount: child.discount,
                    tax_code_id: child.tax_code_id,
                    classification_code,
                });
            }),
        };

        // Find if existed in EditableTable
        const findIndex = newItems.findIndex(i => (
            i?.transfer_transaction?.id === selection.transactionId &&
            i?.transfer_item_id === selection.transactionItemId
        ));

        // Case 1: If not existed in EditableTable,
        // => Add a new item with Transfer-From Information
        if (findIndex === -1)
            return newItems.push(newItem);

        // Case 2: If already existed in EditableTable,
        // => Just add-in Transfer-From Information
        function updateItem(oldItem, newItem) {
            return {
                ...oldItem,
                ...newItem,

                // Can be overwritten
                description: oldItem.description || newItem.description,
                service_date: (oldItem.service_date || newItem.service_date),
                account_id: oldItem.account_id || newItem.account_id,
                discount: oldItem.discount || newItem.discount,
                tax_code_id: oldItem.tax_code_id || newItem.tax_code_id,
                classification_code: oldItem.classification_code || newItem.classification_code,
            };
        }

        const item = newItems[findIndex]; // From Editable Table

        newItems[findIndex] = {
            ...updateItem(item, newItem),

            children: item.children ? (
                item.children.map(oldChild => {
                    const newChild = newItem.children.find(c => (
                        c?.transfer_item_id === oldChild.transactionItemId
                    )) || {};
                    return updateItem(oldChild, newChild);
                })
            ) : null,
        };
        return null;
    });

    // Step 3: Remove previously-selected items from EditableTable
    const finalItems = newItems.filter(item => {
        if (!item.transfer_transaction)
            return true;

        const transactionId = item.transfer_transaction.id;
        const transactionItemId = item.transfer_item_id;

        const exists = flattenSelections.find(selection => (
            selection.transactionId === transactionId &&
            selection.transactionItemId === transactionItemId
        ));

        return !!exists;
    });

    console.log("qq finalItems", finalItems);
    // Update Redux Store
    yield put(
        setItems(finalItems),
    );
}
